export enum HabitPackFormat {
  ROUTINE = 'routine',
  STANDALONE = 'standalone'
}

export enum Mode {
  DEFAULT = 'default',
  ROUTINE = 'routine',
  STANDALONE = 'standalone',
  FREESTYLE = 'freestyle', // Only break-related activities, no routine
  FOCUS_MODE = 'focus_mode',
  LIBRARY = 'library',
  CUSTOM = 'custom'
}

export enum StatCardTypes {
  ROUTINE = 'routine',
  FOCUS_MODE = 'focus_mode'
}

export enum PackEditorTabMode {
  ROUTINE = 'routine',
  STANDALONE = 'standalone',
  FOCUS_MODE = 'focus_mode'
}

export enum TIME_VALIDATION_FIELDS {
  START_TIME = 'start_time',
  END_TIME = 'end_time'
}

export enum ActivityTableFilter {
  ALL = 'all',
  MORNING = 'morning',
  EVENING = 'evening',
  BREAKING = 'breaking'
}

export enum INVALID_FEATURE {
  START_UP = 'start-up',
  SHUTDOWN = 'shutdown',
  BREAK_FREQUENCY = 'break-frequency',
  PACK_NAME = 'pack name',
  PACK_CREATOR_NAME = 'pack creator name',
  PACK_DESCRIPTION = 'pack description',
  PACK_DESCRIPTION_URL = 'pack description url',
  PACK_WELCOME_URL = 'pack welcome url',
  TEXT_EDITOR_CHARACTER_LIMIT = 'text editor character limit',
  STANDALONE_ACTIVITIES = 'standalone activities',
  ALLOWED_APPS = 'allowed apps',
  ALLOWED_URLS = 'allowed urls',
  HABIT_NAME = 'habit_name',
  SLEEP_TIME = 'sleep_time',
  DURATION = 'duration'
}

export enum SUGGESTED_PACK {
  LIBRARY = 'activity library',
  HABIT_PACK = 'habit pack',
  CREATE_NEW_HABIT = 'create new habit'
}

export enum CUSTOM_ROUTINE_TRIGGER {
  ON_DEMAND = 'ON_DEMAND',
  ON_SCHEDULE = 'ON_SCHEDULE'
}

export enum ROUTINE_SUGGESTIONS_REVAMP_STEP {
  ENTRY = 'entry',
  IMPORT = 'import',
  GOALS = 'goals',
  HABIT_SETUP = 'habit_setup',
  SCHEDULE = 'schedule',
  REVIEW = 'review'
}

export enum ROUTINE_SUGGESTIONS_REVAMP_ENTRY_PATH {
  AI_SUGGESTIONS = 'ai_suggestions',
  IMPORT_HABITS = 'import_habits'
}

export enum PROCESSING_TYPE {
  IMAGE = 'image',
  AUDIO = 'audio'
}

export enum ADD_HABITS_MODE {
  IMPORT = 'import',
  RECOMMEND = 'recommend'
}

export enum REVAMP_ROUTINE_SUGGESTIONS_ACTION {
  ADD = 'add',
  DELETE = 'delete',
  UPDATE = 'update',
  REORDER = 'reorder',
  MOVE = 'move'
}

export enum REVAMP_ROUTINE_SUGGESTIONS_FLOW_KEY {
  IMPORT = 'import',
  DEFAULT = 'default'
}

export enum REVAMP_ROUTINE_SUGGESTIONS_IMPORT_MEDIA_TYPE {
  IMAGE = 'image',
  AUDIO = 'audio'
}

export enum MORE_OPTION_REVAMP_TAB {
  TIMING = 'timing',
  VIDEOS = 'videos',
  ALLOWED_APPS = 'allowed-apps',
  LOG_DATA = 'log-data',
  ACTIVITY_CHOICES = 'activity_choices',
  INSTRUCTIONS = 'instructions',
  ADVANCED = 'advanced'
}

export enum SUGGESTED_HABITS_SECTION {
  CHORES = 'chores',
  PRODUCTIVITY = 'productivity',
  WELLBEING = 'wellbeing',
  HEALTH = 'health',
  HEALTHY_HABITS = 'healthyHabits'
}
